export enum ReturnForm
{
    Unset = "Unset",
    Package = "Package",
    Personal = "Personal"
}
